export const CELL_WIDTH = 60
export const FIRST_CELL_WIDTH = 176
